import {
  SET_UPDATE_BANK_ACCOUNT_TOKEN,
  SET_UPDATE_BANK_ACCOUNT_TOKEN_IS_VALID,
} from '../actions'

const initialState = {
  token: null,
  tokenIsValid: null,
}

const updateBankAccountTokenReducer = (state = initialState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case SET_UPDATE_BANK_ACCOUNT_TOKEN:
      newState.token = action.token
      return newState
    case SET_UPDATE_BANK_ACCOUNT_TOKEN_IS_VALID:
      newState.tokenIsValid = action.tokenIsValid
      return newState
    default:
      return newState
  }
}

export default updateBankAccountTokenReducer

export const getToken = (state) => {
  return state.token
}

export const getTokenIsValid = (state) => {
  return state.tokenIsValid
}
